import { render, staticRenderFns } from "./MediaLibraryBrowser.vue?vue&type=template&id=5b69883d&scoped=true"
import script from "./MediaLibraryBrowser.vue?vue&type=script&lang=js"
export * from "./MediaLibraryBrowser.vue?vue&type=script&lang=js"
import style0 from "./MediaLibraryBrowser.vue?vue&type=style&index=0&id=5b69883d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b69883d",
  null
  
)

export default component.exports